(function () {
  let variantMap = {};

  const productInfo = document.querySelector('[data-product-handle]');
  if (!productInfo) return;

  const handle = productInfo.dataset.productHandle;
  if (!handle) return;

  fetch('/products/' + handle + '.js')
    .then(function (res) { return res.json(); })
    .then(function (product) {
      product.variants.forEach(function (v) {
        variantMap[v.id] = v.title;
      });
    });

  function updateSubtitles() {
    const input = document.querySelector('input[name="id"][data-product-select], select[name="id"]');
    if (!input) return;

    const selectedId = parseInt(input.value);
    const title = variantMap[selectedId];

    if (!title || title === 'Default Title') return;

    const formatted = title.replace(/ \/ /g, ' · ');

    document.querySelectorAll('[id^="variant-subtitle-display--"]').forEach(function (el) {
      el.textContent = formatted;
    });
  }

  document.addEventListener('redo:variant-available', updateSubtitles);
  document.addEventListener('redo:variant-unavailable', updateSubtitles);
})();